import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col max-sm:items-center xs:border xs:border-gray-200 max-w-[250px] py-2 bg-white"
}
const _hoisted_2 = { class: "flex flex-row w-full items-center px-4 mb-1" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex-1 flex justify-center" }
const _hoisted_5 = { class: "flex flex-col items-center gap-4" }
const _hoisted_6 = { class: "flex flex-col w-full gap-3" }
const _hoisted_7 = { class: "flex flex-row items-center gap-2 px-4 mb-1" }
const _hoisted_8 = { class: "flex items-center w-full px-4 mb-1" }
const _hoisted_9 = { class: "relative w-full" }
const _hoisted_10 = { class: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "flex flex-col w-full gap-3" }
const _hoisted_13 = { class: "flex flex-row items-center gap-2 px-4 mb-1" }
const _hoisted_14 = { class: "flex items-center w-full px-4 mb-1" }
const _hoisted_15 = { class: "relative w-full" }
const _hoisted_16 = { class: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = { class: "flex flex-col w-full gap-3" }
const _hoisted_19 = { class: "flex flex-row items-center gap-2 px-4 mb-1" }
const _hoisted_20 = { class: "flex items-center w-full px-4 mb-1" }
const _hoisted_21 = { class: "relative w-full" }
const _hoisted_22 = { class: "absolute left-3 top-1/2 -translate-y-1/2 text-gray-500" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "flex flex-col w-full text-left gap-2" }
const _hoisted_25 = { class: "flex flex-row px-4 items-center gap-2" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "flex flex-col w-full text-left gap-2 mb-1" }
const _hoisted_28 = { class: "flex flex-row px-4 items-center gap-2" }
const _hoisted_29 = ["innerHTML"]
const _hoisted_30 = { class: "flex flex-col px-4" }
const _hoisted_31 = { class: "relative" }
const _hoisted_32 = { class: "absolute rounded-md inset-0 w-full h-full pointer-events-none overflow-hidden" }
const _hoisted_33 = ["innerHTML"]
const _hoisted_34 = { class: "flex flex-row justify-between" }
const _hoisted_35 = ["innerHTML"]
const _hoisted_36 = { class: "flex flex-col items-center text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isEnabled)
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", {
              class: "text-lg leading-7 font-medium",
              style: _normalizeStyle({ color: _ctx.textColor })
            }, "Filters", 4)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: "text-lg leading-7 font-medium px-2 py-1 rounded-md",
              style: _normalizeStyle({
            color: _ctx.textColor,
            backgroundColor: _ctx.backgroundColor,
          })
            }, " Clear all ", 4)
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "flex flex-col" }, [
            _createElementVNode("div", { class: "w-5 h-5" }, "☰")
          ], -1))
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", {
                class: "text-base font-medium leading-5 tracking-wide",
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, " Name ", 4)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.SEARCH_ICON,
                    class: "w-5 h-5"
                  }, null, 8, _hoisted_11)
                ]),
                _cache[1] || (_cache[1] = _createElementVNode("input", {
                  type: "text",
                  placeholder: "Search by name",
                  class: "w-full pl-10 pr-24 py-2 border border-gray-300 rounded-lg focus:outline-none",
                  disabled: ""
                }, null, -1)),
                _createElementVNode("span", {
                  class: "absolute right-1 top-1/2 -translate-y-1/2 px-2 py-1 rounded-md",
                  style: _normalizeStyle({
                color: _ctx.textColor,
                backgroundColor: _ctx.backgroundColor,
              })
                }, " Search ", 4)
              ])
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "border-t border-gray-200" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("span", {
                class: "text-base font-medium leading-5 tracking-wide",
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, " Language ", 4)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.SEARCH_ICON,
                    class: "w-5 h-5"
                  }, null, 8, _hoisted_17)
                ]),
                _cache[3] || (_cache[3] = _createElementVNode("input", {
                  type: "text",
                  placeholder: "Search by language",
                  class: "w-full pl-10 pr-24 py-2 border border-gray-300 rounded-lg focus:outline-none",
                  disabled: ""
                }, null, -1)),
                _createElementVNode("span", {
                  class: "absolute right-1 top-1/2 -translate-y-1/2 px-2 py-1 rounded-md",
                  style: _normalizeStyle({
                color: _ctx.textColor,
                backgroundColor: _ctx.backgroundColor,
              })
                }, " Search ", 4)
              ])
            ]),
            _cache[4] || (_cache[4] = _createElementVNode("hr", { class: "border-t border-gray-200" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("span", {
                class: "text-base font-medium leading-5 tracking-wide",
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, " Location ", 4)
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("div", {
                    innerHTML: _ctx.SEARCH_ICON,
                    class: "w-5 h-5"
                  }, null, 8, _hoisted_23)
                ]),
                _cache[5] || (_cache[5] = _createElementVNode("input", {
                  type: "text",
                  placeholder: "Search by location",
                  class: "w-full pl-10 pr-24 py-2 border border-gray-300 rounded-lg focus:outline-none",
                  disabled: ""
                }, null, -1)),
                _createElementVNode("span", {
                  class: "absolute right-1 top-1/2 -translate-y-1/2 px-2 py-1 rounded-md",
                  style: _normalizeStyle({
                color: _ctx.textColor,
                backgroundColor: _ctx.backgroundColor,
              })
                }, " Search ", 4)
              ])
            ]),
            _cache[6] || (_cache[6] = _createElementVNode("hr", { class: "border-t border-gray-200" }, null, -1))
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", {
                innerHTML: _ctx.SECONDARY_CALENDAR_ICON,
                class: "w-5 h-5",
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, null, 12, _hoisted_26),
              _createElementVNode("span", {
                class: "text-base font-medium leading-5 tracking-wide",
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, " Soonest availability ", 4)
            ]),
            _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"flex flex-col items-start px-4 gap-2\"><span class=\"text-sm font-medium leading-5 tracking-wide rounded-full px-2 py-1 bg-gray-100 text-gray-400\"> ASAP (Within next 2 hrs) </span></div><div class=\"flex flex-col w-full text-left rounded-md px-4\"><p class=\"text-gray-500 text-sm font-normal leading-5\"> All times listed in UTC timezone. </p></div><hr class=\"border-t border-gray-200 mt-1\">", 3))
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", {
                innerHTML: _ctx.STARS_ICON,
                class: "w-5 h-5"
              }, null, 8, _hoisted_29),
              _createElementVNode("span", {
                class: "text-base font-medium leading-5 tracking-wide",
                style: _normalizeStyle({ color: _ctx.backgroundColor })
              }, "Tags", 4)
            ]),
            _cache[8] || (_cache[8] = _createStaticVNode("<div class=\"flex flex-col px-4 max-w-[200px]\"><div class=\"flex flex-wrap gap-2 mt-3\"><span class=\"flex items-center rounded-md px-3 py-1.5 bg-gray-200 text-gray-500 text-sm\"> Tag 1 </span><span class=\"flex items-center rounded-md px-3 py-1.5 bg-gray-200 text-gray-500 text-sm\"> Tag 2 </span><span class=\"flex items-center rounded-md px-3 py-1.5 bg-gray-200 text-gray-500 text-sm\"> Tag 3 </span></div><hr class=\"border-t border-gray-200 mt-1\"></div>", 1))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", {
                  innerHTML: _ctx.JOIN_EXPERT_PROGRAM_BACKGROUND,
                  class: "w-full h-full",
                  style: _normalizeStyle({
                color: `color-mix(in srgb, ${_ctx.backgroundColor} 80%, black 20%)`,
                backgroundColor: _ctx.backgroundColor,
              })
                }, null, 12, _hoisted_33)
              ]),
              _createElementVNode("div", {
                class: "relative flex flex-col gap-2 px-4 py-2 rounded-md text-left justify-between bg-no-repeat bg-cover",
                style: _normalizeStyle({ color: _ctx.textColor })
              }, [
                _createElementVNode("div", _hoisted_34, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "text-lg leading-9 font-medium" }, "Are you an Expert?", -1)),
                  _createElementVNode("div", {
                    innerHTML: _ctx.DOLLAR_ICON,
                    class: "w-5 h-5",
                    style: _normalizeStyle({ color: _ctx.textColor })
                  }, null, 12, _hoisted_35)
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "flex flex-col" }, [
                  _createElementVNode("span", { class: "text-sm leading-5 font-medium" }, "Earn with your expertise")
                ], -1)),
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("span", {
                    class: "px-4 py-2 w-full border border-gray-300 rounded-md bg-transparent text-xs sm:text-sm font-medium leading-5 bg-white",
                    style: _normalizeStyle({ color: _ctx.backgroundColor })
                  }, " Join our Expert Program ", 4)
                ])
              ], 4)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}